//React
import React from "react";
import { useEffect, useState } from "react";
//Material UI
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
//RTK Query
import { useNewUserMutation, useGetUserGroupsAvailableQuery } from "../../Features/api/apiSlice";
//Components
import UserDialog from "./UserDialog";
import { PrimaryButton } from "../../Global/other/Buttons";

const EMPTY = { email: "", first_name: "", last_name: "" };

export default function ButtonAddUser() {
  const { data: available_user_groups, isSuccess: isAvailableGroupsSuccess } =
    useGetUserGroupsAvailableQuery();
  const [addNewUser, { isLoading: add_new_user_loading }] = useNewUserMutation();

  const [values, setValues] = useState(EMPTY);
  const [selected_user_groups, setSelectedUserGroups] = useState([]);
  const [open, setOpen] = useState(false);

  const resetState = () => {
    setValues(EMPTY);
    setSelectedUserGroups([]);
  };

  const handleClose = () => {
    setOpen(false);
    resetState();
  };

  const handleChange = (name, value) => setValues((current) => ({ ...current, [name]: value }));

  const handleToggleGroup = (unique_name, checked) => {
    setSelectedUserGroups((current) =>
      checked ? [...current, unique_name] : current.filter((name) => name !== unique_name)
    );
  };

  const handleOnSubmit = (event) => {
    event.preventDefault();
    addNewUser({ body: { ...values, user_groups: selected_user_groups } });
  };

  useEffect(() => {
    if (!add_new_user_loading) {
      setOpen(false);
      resetState();
    }
  }, [add_new_user_loading]);

  if (!isAvailableGroupsSuccess) return <></>;

  return (
    <>
      <PrimaryButton type="button" onClick={() => setOpen(true)}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        Add a User
      </PrimaryButton>

      {add_new_user_loading ? (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(4px)",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <UserDialog
          open={open}
          title="Add User"
          idPrefix="add-user"
          values={values}
          onChange={handleChange}
          availableGroups={available_user_groups.data}
          selectedGroups={selected_user_groups}
          onToggleGroup={handleToggleGroup}
          onClose={handleClose}
          onSubmit={handleOnSubmit}
          actions={<PrimaryButton type="submit">Add</PrimaryButton>}
        />
      )}
    </>
  );
}
